var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { createReducer } from "typesafe-actions";
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import "../epics/index.js";
import { createAssignmentUnitEpicReducer } from "../epics/epicsV2.js";
import { resetCreateResult } from "../epics/actions.js";
const defaultReducerState = {
  createResult: getDefaultAsyncWrapperObj()
};
const actionsReducer = createReducer(defaultReducerState).handleAction(resetCreateResult, (state) => __spreadProps(__spreadValues({}, state), {
  createResult: getDefaultAsyncWrapperObj()
}));
const reducer = (state = defaultReducerState, action) => {
  state = createAssignmentUnitEpicReducer.reduxChange(state, action);
  state = actionsReducer(state, action);
  return state;
};
export {
  reducer as default,
  defaultReducerState,
  reducer
};
//# sourceMappingURL=ducks.js.map
